import myData from '../_json/creole.json';
export default function Messages (){
    const allMessages = myData
    return allMessages
}